import { IconModel } from '../models/icon/icon.model';
import { IconStylingModel } from '../models/icon/icon-styling.model';

import { BreadCrumbModel } from '../models/bread-crumb/bread-crumb.model';
import { BreadCrumbStylingModel } from '../models/bread-crumb/bread-crumb-styling.model';

export const /** @type {?} */ BreadCrumbTemplates = {
  defaultTemplate: {
    property: new BreadCrumbModel({
      display: true,
      disable: false,
      icon: new IconModel({
        name: 'keyboard_arrow_right'
      }),
      links: [{
        path: 'home',
        alias: 'home'
      }]

    }),
    style : new BreadCrumbStylingModel({
      container: {
        class: 'default-container'
      },
      iconStyling: {
        icon: {
          class: 'greyIcon'
        }
      },
      link: {
        class: 'greyLink'
      }
    })
  }
}
